var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CCD4D8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.3 73.254c2.134 0 3.986-.472 5.558-1.415 1.573-.943 2.783-2.201 3.63-3.774.848-1.572 1.272-3.329 1.272-5.27 0-.875-.123-1.75-.37-2.625-.245-.875-.587-1.723-1.025-2.543L49.383 5.291c-.985-1.723-2.283-3.035-3.897-3.937C43.873.45 42.164 0 40.36 0c-1.75 0-3.438.451-5.065 1.354-1.627.902-2.933 2.214-3.917 3.937L1.395 57.668C.465 59.254 0 60.963 0 62.795c0 1.941.43 3.698 1.292 5.27.861 1.573 2.071 2.83 3.63 3.774 1.558.943 3.39 1.415 5.496 1.415h59.883zm-.081-5.578H10.5c-1.45 0-2.611-.492-3.486-1.477-.875-.984-1.313-2.119-1.313-3.404 0-.383.041-.786.123-1.21.082-.424.233-.855.451-1.292L36.217 7.957c.465-.793 1.066-1.38 1.804-1.764.739-.382 1.518-.574 2.338-.574.82 0 1.6.185 2.338.554.739.369 1.34.964 1.805 1.784l29.9 52.377c.41.793.616 1.613.616 2.46 0 1.286-.445 2.42-1.333 3.405-.89.985-2.044 1.477-3.466 1.477zM40.4 47.25c1.778 0 2.68-.957 2.707-2.871l.534-20.549c.027-.93-.28-1.695-.923-2.297-.643-.601-1.429-.902-2.359-.902-.957 0-1.743.294-2.358.882-.615.588-.91 1.346-.882 2.276l.451 20.59c.055 1.914.998 2.871 2.83 2.871zm0 12.346c1.067 0 1.99-.37 2.769-1.108.78-.738 1.169-1.64 1.169-2.707 0-1.066-.39-1.975-1.17-2.727-.778-.752-1.701-1.128-2.768-1.128-1.093 0-2.03.376-2.81 1.128-.778.752-1.168 1.66-1.168 2.727 0 1.04.396 1.935 1.19 2.687.792.752 1.722 1.128 2.788 1.128z",
    transform: "translate(-147 -213) translate(147 213)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.0ce1a173c32fe76f31fae3b403c9c0f4.svg";
export { ForwardRef as ReactComponent };